import { MissingReportReminderType, MissingReportType } from 'api/types/missingInformationReportTypes';
import { routePaths } from 'components/Routes/data';

type MissingInformationSummaryTableData = {
  id: number;
  title: string;
  priority: 'high' | 'low';
  url: string;
  type: MissingReportType;
};

export const missingInformationSummaryTableData: MissingInformationSummaryTableData[] = [
  {
    id: 1,
    title: 'Unverified Bank Account Details',
    priority: 'high',
    url: routePaths.approvalWorkflows.myRequests.employeeBankAccount.pendingApprovals,
    type: 'unverified_bank_account_details',
  },
  {
    id: 2,
    title: 'Bank Account Details',
    priority: 'high',
    url: routePaths.reports.missingInformation.bankAccount,
    type: 'bank_account_details',
  },
  {
    id: 3,
    title: 'Statutory Contributions',
    priority: 'high',
    url: routePaths.reports.missingInformation.statutory,
    type: 'statutory_contributions',
  },
  {
    id: 4,
    title: 'Personal Details',
    priority: 'low',
    url: routePaths.reports.missingInformation.personal,
    type: 'personal_details',
  },
];

export const sendReminderModalDescriptions: Record<MissingReportReminderType, string> = {
  personal_details:
    'RazorpayX Payroll will email all employees in your organization with missing personal details.',
  bank_account_details:
    'RazorpayX Payroll will email all employees in your organization with missing/invalid bank account details.',
  statutory_contributions:
    'RazorpayX Payroll will email all employees in your organization with missing/invalid statutory contribution details.',
};
